<template>
    <div class="form-elements">
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Turmas Teóricas">
                  <FormTurma></FormTurma>
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
import FormTurma from './FormTurma'
export default {
  name: 'form-turma-cadastro',
  components: {
    FormTurma
  }
}
</script>
